module.exports = __webpack_public_path__ + "static/media/CC20-AP140-12-FAICO.d74a031a.pdf";